(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairCreateSurveyController', PhysicalFairCreateSurveyController);

    PhysicalFairCreateSurveyController.$inject = ['PhysicalFairService', 'VirtualFairService', 'ExpoService', 'SurveyService', 'toastr', '$timeout', '$uibModal'];

    function PhysicalFairCreateSurveyController(PhysicalFairService, VirtualFairService, ExpoService, SurveyService, toastr, $timeout, $uibModal) {
        var vm = this;
        vm.getSurveys           = getSurveys;        
        vm.getEvents            = getEvents;
        vm.activate             = activate;        
        vm.downloadCSVExpo      = downloadCSVExpo;
        vm.downloadCSVVirtualFair = downloadCSVVirtualFair;
        vm.setTitle             = setTitle;
        vm.copy                 = copy;
        vm.surveySelected       = '';
        vm.eventSelected        = '';
        vm.eventTypeSelected    = '';
        vm.title                = '';
        vm.eventsTypes          = [
                                    {id: 'physical-fairs', name : 'Physical Fairs'}, 
                                    {id: 'virtual-fairs', name : 'Virtual Fairs'}
                                  ];
        vm.serviceSelected      = 'physical-fairs';
        vm.flag                 = false;

        function activate() {
            vm.getSurveys();
        }

        function getSurveys() {
            SurveyService.getSurveys().then(function(response) {
                vm.surveys = response.data;
            }).catch(function(err) {
            });
        }

        function getEvents()
        {
            vm.query = {};

            if(vm.eventTypeSelected === 'physical-fairs')
            {                
                ExpoService.getExpoBySemester(vm.query).then(function (response) {
                    vm.events = response.data;
                });
            } 
            else if(vm.eventTypeSelected === 'virtual-fairs')
            {
                VirtualFairService.getAll(vm.query).then(function (response) {
                    vm.events = response.data;
                });
            }            
        }

        function copy() {
            let fields   = {};
            if(vm.surveySelected != '') {
                fields['survey_id'] = vm.surveySelected;
                fields['event_id'] = vm.eventSelected.id;
                fields['title'] = vm.title;
            }
            PhysicalFairService.copySurvey(fields).then(function(response) {
                vm.getSurveys();
                vm.surveySelected       = '';
                vm.eventSelected        = '';
                vm.eventTypeSelected    = '';
                vm.title                = '';

                toastr.success('Survey copied successfully!');

            });
        }

        function downloadCSVExpo(survey_token, expo_location_id) {
            let fields   = {};
            fields['survey_token'] = survey_token;
            fields['expo_location_id'] = expo_location_id;

            PhysicalFairService.downloadCSVExpo(fields).success(function(data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = 'survey_representatives.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).error(function(data, status, headers, config) {
                // handle error
            });
        }

        function downloadCSVVirtualFair(survey_token, virtual_fair_id) {
            let fields   = {};
            fields['survey_token'] = survey_token;
            fields['virtual_fair_id'] = virtual_fair_id;

            PhysicalFairService.downloadCSVVirtualFair(fields).success(function(data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = 'survey_representatives.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).error(function(data, status, headers, config) {
                // handle error
            });
        }

        function setTitle() {
            vm.title = vm.eventSelected.name;
            console.log(vm.title);
        }

        vm.activate();        

    }
})();
